export default {
  title: {
    add: 'Tilføj script',
    update: 'Opdater script',
  },
  form: {
    strategy: {
      label: 'Strategi',
      placeholder: 'Vælg strategi',
    },
    source: {
      label: 'Kilde (src)',
      placeholder: 'Indtast kilde',
    },
    async: {
      label: 'Async',
      placeholder: 'Vælg async',
    },
    content: {
      label: 'Indhold',
      placeholder: 'Indtast indhold',
    },
  },
  alert: {
    use_case: 'Anvendelsestilfælde',
  },
  buttons: {
    save: 'Gem',
  },
};
